import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterProjectCode } from '@/api/model/interfaces';

export default class RegisterProjectCodeOdata extends OdataManager<RegisterProjectCode> {}
